import * as joint from '@clientio/rappid';
import { TranslocoService } from '@jsverse/transloco';
import { ComponentConverter } from 'shared/domain';

import {
  ActivityDefinitionDto,
  ComponentDto,
  FlowchartElementType,
  FlowchartLinkDto,
  FlowchartSelectionBehaviorDto,
  SelectionBehavior,
} from '@treetop/shared/model';

import { BasicNode } from './BasicNode';
import { IFlowchartNode } from './IFlowchartNode';
import OperationsService from '../infrastructure/operations/operations.service';
import SubflowService from '../infrastructure/operations/subflow.service';

export class FlowchartSelectionBehavior extends BasicNode<FlowchartSelectionBehaviorDto> implements IFlowchartNode {
  constructor(element: FlowchartSelectionBehaviorDto) {
    super(element);
  }

  addOutgoingLink(link: FlowchartLinkDto): void {
    this.element.outgoingLinks = this.element.outgoingLinks || [];
    this.element.outgoingLinks.push(link);
  }

  removeOutgoingLink(linkIndex: number): void {
    this.element.outgoingLinks.splice(linkIndex, 1);
  }

  async setPropertiesAfterSearch(
    definition: ComponentDto,
    medicationRequests: ActivityDefinitionDto[],
    componentConverter: ComponentConverter,
    selectedElementView: joint.dia.ElementView,
    translocoService?: TranslocoService,
  ): Promise<void> {
    //Do nothing
  }

  addToGraph(
    graph: joint.dia.Graph,
    paper: joint.dia.Paper,
    operationsService: OperationsService,
    subflowService: SubflowService,
    translocoService?: TranslocoService,
    allowEvents = false,
  ) {
    const selectionBehavior = operationsService.selectionBehaviorNodeService.createSelectionBehaviorNode(
      paper,
      this.element.selectionBehavior,
      this.element.positionX,
      this.element.positionY,
      this.element.id,
      allowEvents,
    );
    graph.addCell(selectionBehavior);
  }

  setPropertiesForInit(element): void {
    super.setPropertiesForInit(element);
    this.element.selectionBehavior = SelectionBehavior.And;
    this.element.elementType = FlowchartElementType.FlowchartSelectionBehavior;
  }
}
